// extracted by css-extract-rspack-plugin
export default {"AddMXBankAccountDrawer":"sputnik__AddMXBankAccountDrawer__mSHYU","addMxBankAccountDrawer":"sputnik__AddMXBankAccountDrawer__mSHYU"};